import {
  Archive,
  ClipboardList,
  Contact,
  FileSpreadsheet,
  FolderKanban,
  ClipboardCheck,
  User,
  UserPlus,
} from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup, type StaffNavNode } from '../nav-node'

export function buildHrGroup(ctx: StaffNavContext): StaffNavGroup | null {
  const children: StaffNavNode[] = []

  if (ctx.showWalkInNav && !ctx.walkInListedUnderRecruitment) {
    children.push(
      leaf(
        'walk_in_hr',
        'Reception Walk-in',
        AppPaths.hrWalkInIntake,
        UserPlus,
        ['walk in', 'reception', 'intake'],
      ),
    )
  }
  if (ctx.showVisaOnboardingNav) {
    children.push(
      leaf(
        'visa_onboarding',
        'Visa & Onboarding',
        AppPaths.hrOnboardingHub,
        FolderKanban,
        ['visa', 'onboarding', 'cases'],
        {
          activeWhenPrefix: true,
          // Walk-in lives under /hr/onboarding/walk-in — do not light both.
          activeExcludePrefixes: [AppPaths.hrWalkInIntake],
        },
      ),
    )
  }
  if (ctx.showInterviewIntakeNav) {
    children.push(
      leaf(
        'interview_applications',
        'Interview Applications',
        AppPaths.hrInterviewApplications,
        ClipboardCheck,
        ['interview', 'applications', 'shortlisted', 'walk-in', 'intake'],
        { activeWhenPrefix: true },
      ),
    )
  }
  if (ctx.showWorkforceDirectory) {
    children.push(
      leaf(
        'employee_directory',
        'Employee Directory',
        AppPaths.workforceDirectory,
        Contact,
        ['employee', 'directory', 'roster'],
        {
          activeWhenPrefix: true,
          activeExcludePrefixes: [AppPaths.workforceCompleteness],
        },
      ),
    )
    children.push(
      leaf(
        'employee_completeness',
        'Employee Completeness',
        AppPaths.workforceCompleteness,
        FileSpreadsheet,
        ['completeness', 'missing', 'gaps', 'backfill', 'import'],
      ),
    )
  }
  if (ctx.showStaffPersonalDetailsNav) {
    children.push(
      leaf(
        'staff_personal_details',
        'Staff Personal Details',
        AppPaths.hrStaffPersonalDetails,
        ClipboardList,
        ['staff', 'personal', 'details', 'intake', 'form'],
        { activeWhenPrefix: true },
      ),
    )
  }
  if (ctx.showStaffPersonalDetailsImportNav) {
    children.push(
      leaf(
        'staff_personal_details_import',
        'Import Staff Sheet',
        AppPaths.hrStaffPersonalDetailsImport,
        FileSpreadsheet,
        ['import', 'bulk', 'excel', 'sheet', 'upload', 'supervisor'],
      ),
    )
  }
  if (ctx.showPurgedEmployees) {
    children.push(
      leaf(
        'purged_employees',
        'Purged Employees',
        AppPaths.workforcePurgedEmployees,
        Archive,
        ['purge', 'archive', 'deleted employees'],
      ),
    )
  }

  return group('hr', 'HR', User, ['hr', 'onboarding', 'workforce', 'employees'], children)
}
